import moment from "moment";
import React from "react";
import { TCRBRecord } from "../../../../../redux/app/crb/@types";
import { TCRBH1 } from "../../../../../redux/app/crb/groups/crb-h";
import { commonUtils } from "../../../../../redux/_common";
import CRBTableRows from "../CRBTableRows";

type OwnProps = {
	crbRecord: TCRBRecord;
	isStrikedOff?: boolean;
};
type CRBH1PreviewProps = OwnProps;
function CRBH1Preview(props: CRBH1PreviewProps) {
	const crbRecord = props.crbRecord as TCRBH1;
	const operationDate = moment(crbRecord.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	function renderMain() {
		return (
			<CRBTableRows
				record={crbRecord}
				tableRows={[
					[operationDate, "H", 22, renderItem22()],
					[null, null, 23, renderItem23()],
					[null, null, 24, renderItem24()],
					[null, null, 25, renderItem25()],
					[null, null, "NOTE", crbRecord.remarks],
				]}
			/>
		);
	}

	function renderItem22() {
		if (crbRecord.item22.tanks.length > 0) {
			const totalQuantityDischarged = crbRecord.item22.tanks.reduce<number>(
				(result, tank) => commonUtils.addUp(tank.transferQuantity, result),
				0
			);
			return (
				<>
					<table className="min-w-full table-auto border-collapse">
						<thead className="bg-gray-600">
							<tr>
								<th className="px-4 py-2 border text-center">Tank</th>
								<th className="px-4 py-2 border text-center">
									Discharge Quantity
								</th>
							</tr>
						</thead>
						<tbody>
							{crbRecord.item22.tanks.map((tank) => {
								return (
									<tr key={tank.selectedTank.id}>
										<td className="px-4 py-2 border text-center">
											{tank.selectedTank.tankCode}
										</td>
										<td className="px-4 py-2 border text-center">
											{tank.transferQuantity}
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>

					<br />
					<h4 className="font-medium uppercase">
						Total Ballast Discharged: {totalQuantityDischarged.toFixed(2)} M³
					</h4>
				</>
			);
		}
		return <>----</>;
	}
	function renderItem23() {
		let { placeOfBallast } = crbRecord.item23;
		if (placeOfBallast.place === "AT_SEA") {
			return (
				<>
					<h4 className="font-medium uppercase">
						Commenced Position: {placeOfBallast.startPosition.latitude} /{" "}
						{placeOfBallast.startPosition.longitude}
					</h4>
					<h4 className="font-medium uppercase">
						Stopped Position: {placeOfBallast.endPosition.latitude}/
						{placeOfBallast.endPosition.longitude}
					</h4>
				</>
			);
		}
		if (placeOfBallast.place === "AT_RECEPTION_FACILITY") {
			let {
				receiptNumber,
				receptionFacilityName,
				portName,
				receiptAttachment,
			} = placeOfBallast;
			return (
				<h4 className="font-medium uppercase">
					<ul>
						<li>Port: {portName}</li>
						<li>Reception Facility : {receptionFacilityName}</li>
						<li>Receipt: {receiptNumber}</li>
						<li>Attachment: {receiptAttachment}</li>
					</ul>
				</h4>
			);
		} else {
			return null;
		}
	}
	function renderItem24() {
		if (crbRecord.item22.tanks.length > 0) {
			const smtStartDate = crbRecord.item22.tanks[0].startDate;
			const smtStartTime = crbRecord.item22.tanks[0].startTime;
			const smtEndDate =
				crbRecord.item22.tanks[crbRecord.item22.tanks.length - 1].endDate;
			const smtEndTime =
				crbRecord.item22.tanks[crbRecord.item22.tanks.length - 1].endTime;

			const dateTimeLocal = `${smtStartDate}T${smtStartTime}:00${crbRecord.timeZone}`;
			const utcTime = moment.utc(dateTimeLocal);

			return (
				<>
					<>
						Commenced - {utcTime.format("HH:mm")} hrs (UTC) ({smtStartTime} SMT)
						on {moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
					</>
					<br />
					<>
						Stopped - {utcTime.format("HH:mm")} hrs (UTC) ({smtEndTime} SMT) on{" "}
						{moment(smtEndDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
					</>
				</>
			);
		}
	}
	function renderItem25() {
		return (
			<h4 className="font-medium uppercase">
				Ship's Speed during Discharge: {crbRecord.item25.speed} knots
			</h4>
		);
	}

	return renderMain();
}

export default CRBH1Preview;
